import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { authApi } from "../apis/Auth.api";
import { gdprApi } from "../apis/Gdpr.api";
import { currentUserApi } from "../apis/CurrentUser.api";
import sessionSlice from "./slices/sessionSlice";
import {
  deleteDialogSlice,
  descriptionAlertSlice,
  passwordDialogSlice,
  paginationSlice,
  dynamicSnackbarSlice,
  localeSlice,
} from '../share';
import { addressApi, addressNormalizerMiddleware } from "../address/apis/Address.api";

import { userAddressApi, userAddressNormalizerMiddleware } from "../address/apis/UserAddress.api";


import { membersGroupApi, membersGroupNormalizerMiddleware } from "../auth/apis/MembersGroup.api";

import { userApi, userNormalizerMiddleware } from "../auth/apis/User.api";

import { userSessionApi, userSessionNormalizerMiddleware } from "../auth/apis/UserSession.api";

import { roleApi, roleNormalizerMiddleware } from "../auth/apis/Role.api";

import { rolePermissionApi, rolePermissionNormalizerMiddleware } from "../auth/apis/RolePermission.api";

import { membersGroupUserApi, membersGroupUserNormalizerMiddleware } from "../auth/apis/MembersGroupUser.api";

import { scopeGroupApi, scopeGroupNormalizerMiddleware } from "../auth/apis/ScopeGroup.api";

import { roleAssignmentApi, roleAssignmentNormalizerMiddleware } from "../auth/apis/RoleAssignment.api";


import { locationApi, locationNormalizerMiddleware } from "../location/apis/Location.api";


import { timberClassApi, timberClassNormalizerMiddleware } from "../timber/apis/TimberClass.api";

import { thicknessClassApi, thicknessClassNormalizerMiddleware } from "../timber/apis/ThicknessClass.api";

import { timberTypeApi, timberTypeNormalizerMiddleware } from "../timber/apis/TimberType.api";

import { pricingProfileApi, pricingProfileNormalizerMiddleware } from "../timber/apis/PricingProfile.api";

import { priceApi, priceNormalizerMiddleware } from "../timber/apis/Price.api";

import { buyerApi, buyerNormalizerMiddleware } from "../timber/apis/Buyer.api";

import { buyerUserApi, buyerUserNormalizerMiddleware } from "../timber/apis/BuyerUser.api";

import { roadCarrierApi, roadCarrierNormalizerMiddleware } from "../timber/apis/RoadCarrier.api";

import { contractorApi, contractorNormalizerMiddleware } from "../timber/apis/Contractor.api";

import { contractorUserApi, contractorUserNormalizerMiddleware } from "../timber/apis/ContractorUser.api";

import { forestOwnerApi, forestOwnerNormalizerMiddleware } from "../timber/apis/ForestOwner.api";

import { providerApi, providerNormalizerMiddleware } from "../timber/apis/Provider.api";

import { providerUserApi, providerUserNormalizerMiddleware } from "../timber/apis/ProviderUser.api";

import { accountingUserApi, accountingUserNormalizerMiddleware } from "../timber/apis/AccountingUser.api";

import { cuttingApi, cuttingNormalizerMiddleware } from "../timber/apis/Cutting.api";

import { timberStorageApi, timberStorageNormalizerMiddleware } from "../timber/apis/TimberStorage.api";

import { shipmentApi, shipmentNormalizerMiddleware } from "../timber/apis/Shipment.api";

import { logApi, logNormalizerMiddleware } from "../timber/apis/Log.api";

import { cordwoodApi, cordwoodNormalizerMiddleware } from "../timber/apis/Cordwood.api";

import { treeMarkingApi, treeMarkingNormalizerMiddleware } from "../timber/apis/TreeMarking.api";

import { logHistoryApi, logHistoryNormalizerMiddleware } from "../timber/apis/LogHistory.api";

import { cordwoodHistoryApi, cordwoodHistoryNormalizerMiddleware } from "../timber/apis/CordwoodHistory.api";

import { shipmentHistoryApi, shipmentHistoryNormalizerMiddleware } from "../timber/apis/ShipmentHistory.api";

import { mergedHistoryApi, mergedHistoryNormalizerMiddleware } from "../timber/apis/MergedHistory.api";


import gdprSlice from "./slices/gdprSlice";
import preferencesSlice from "./slices/preferencesSlice";
import searchSlice from "./slices/searchSlice";
import {defaultLocale} from "../share/components/localization/Locale/locales.ts";



const reducers = {
  [deleteDialogSlice.name]: deleteDialogSlice.reducer,
  [descriptionAlertSlice.name]: descriptionAlertSlice.reducer,
  [dynamicSnackbarSlice.name]: dynamicSnackbarSlice.reducer,
  [passwordDialogSlice.name]: passwordDialogSlice.reducer,
  [paginationSlice.name]: paginationSlice.reducer,
  [localeSlice.name]: localeSlice.reducer,
  [sessionSlice.name]: sessionSlice.reducer,
  [gdprSlice.name]: gdprSlice.reducer,
  [preferencesSlice.name]: preferencesSlice.reducer,
  [searchSlice.name]: searchSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [gdprApi.reducerPath]: gdprApi.reducer,
  [currentUserApi.reducerPath]: currentUserApi.reducer,
  [addressApi.reducerPath]: addressApi.reducer,
  [userAddressApi.reducerPath]: userAddressApi.reducer,
  
  [membersGroupApi.reducerPath]: membersGroupApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [userSessionApi.reducerPath]: userSessionApi.reducer,
  [roleApi.reducerPath]: roleApi.reducer,
  [rolePermissionApi.reducerPath]: rolePermissionApi.reducer,
  [membersGroupUserApi.reducerPath]: membersGroupUserApi.reducer,
  [scopeGroupApi.reducerPath]: scopeGroupApi.reducer,
  [roleAssignmentApi.reducerPath]: roleAssignmentApi.reducer,
  
  [locationApi.reducerPath]: locationApi.reducer,
  
  [timberClassApi.reducerPath]: timberClassApi.reducer,
  [thicknessClassApi.reducerPath]: thicknessClassApi.reducer,
  [timberTypeApi.reducerPath]: timberTypeApi.reducer,
  [pricingProfileApi.reducerPath]: pricingProfileApi.reducer,
  [priceApi.reducerPath]: priceApi.reducer,
  [buyerApi.reducerPath]: buyerApi.reducer,
  [buyerUserApi.reducerPath]: buyerUserApi.reducer,
  [roadCarrierApi.reducerPath]: roadCarrierApi.reducer,
  [contractorApi.reducerPath]: contractorApi.reducer,
  [contractorUserApi.reducerPath]: contractorUserApi.reducer,
  [forestOwnerApi.reducerPath]: forestOwnerApi.reducer,
  [providerApi.reducerPath]: providerApi.reducer,
  [providerUserApi.reducerPath]: providerUserApi.reducer,
  [accountingUserApi.reducerPath]: accountingUserApi.reducer,
  [cuttingApi.reducerPath]: cuttingApi.reducer,
  [timberStorageApi.reducerPath]: timberStorageApi.reducer,
  [shipmentApi.reducerPath]: shipmentApi.reducer,
  [logApi.reducerPath]: logApi.reducer,
  [cordwoodApi.reducerPath]: cordwoodApi.reducer,
  [treeMarkingApi.reducerPath]: treeMarkingApi.reducer,
  [logHistoryApi.reducerPath]: logHistoryApi.reducer,
  [cordwoodHistoryApi.reducerPath]: cordwoodHistoryApi.reducer,
  [shipmentHistoryApi.reducerPath]: shipmentHistoryApi.reducer,
  [mergedHistoryApi.reducerPath]: mergedHistoryApi.reducer,
  
  
};

const rootReducer = combineReducers<typeof reducers>(reducers);

const initialState = {
  locale: {
    localeKey: defaultLocale,
  }
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false
    }).concat([
      
      authApi.middleware,
      currentUserApi.middleware,
      addressApi.middleware,
      addressNormalizerMiddleware,
      userAddressApi.middleware,
      userAddressNormalizerMiddleware,
      
      membersGroupApi.middleware,
      membersGroupNormalizerMiddleware,
      userApi.middleware,
      userNormalizerMiddleware,
      userSessionApi.middleware,
      userSessionNormalizerMiddleware,
      roleApi.middleware,
      roleNormalizerMiddleware,
      rolePermissionApi.middleware,
      rolePermissionNormalizerMiddleware,
      membersGroupUserApi.middleware,
      membersGroupUserNormalizerMiddleware,
      scopeGroupApi.middleware,
      scopeGroupNormalizerMiddleware,
      roleAssignmentApi.middleware,
      roleAssignmentNormalizerMiddleware,
      
      locationApi.middleware,
      locationNormalizerMiddleware,
      
      timberClassApi.middleware,
      timberClassNormalizerMiddleware,
      thicknessClassApi.middleware,
      thicknessClassNormalizerMiddleware,
      timberTypeApi.middleware,
      timberTypeNormalizerMiddleware,
      pricingProfileApi.middleware,
      pricingProfileNormalizerMiddleware,
      priceApi.middleware,
      priceNormalizerMiddleware,
      buyerApi.middleware,
      buyerNormalizerMiddleware,
      buyerUserApi.middleware,
      buyerUserNormalizerMiddleware,
      roadCarrierApi.middleware,
      roadCarrierNormalizerMiddleware,
      contractorApi.middleware,
      contractorNormalizerMiddleware,
      contractorUserApi.middleware,
      contractorUserNormalizerMiddleware,
      forestOwnerApi.middleware,
      forestOwnerNormalizerMiddleware,
      providerApi.middleware,
      providerNormalizerMiddleware,
      providerUserApi.middleware,
      providerUserNormalizerMiddleware,
      accountingUserApi.middleware,
      accountingUserNormalizerMiddleware,
      cuttingApi.middleware,
      cuttingNormalizerMiddleware,
      timberStorageApi.middleware,
      timberStorageNormalizerMiddleware,
      shipmentApi.middleware,
      shipmentNormalizerMiddleware,
      logApi.middleware,
      logNormalizerMiddleware,
      cordwoodApi.middleware,
      cordwoodNormalizerMiddleware,
      treeMarkingApi.middleware,
      treeMarkingNormalizerMiddleware,
      logHistoryApi.middleware,
      logHistoryNormalizerMiddleware,
      cordwoodHistoryApi.middleware,
      cordwoodHistoryNormalizerMiddleware,
      shipmentHistoryApi.middleware,
      shipmentHistoryNormalizerMiddleware,
      mergedHistoryApi.middleware,
      mergedHistoryNormalizerMiddleware,
      
      
    ]);
  },
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: initialState,
  enhancers: (defaultEnhancers) => defaultEnhancers(),
});


export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
